import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {RequestPage} from '../../model/pagination/request/request-page.model';

@Injectable()
export class PendingRequestsResolver implements Resolve<Observable<RequestPage>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<RequestPage> {
    const pageIndex = route.queryParams['pageIndex'] ?? 0;
    const pageSize = route.queryParams['pageSize'] ?? 20;
    return this.facadeService.getPagePendingRequests(pageIndex, pageSize, {}).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
